import { useCallback } from 'react';
import { Button, DateTimeRangePicker, Flex, PropertyGrid, TabPane, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { useValueChange } from '@leverege/ui-hooks';
import { ItemEditor } from '@leverege/ui-attributes';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import { Plugins } from '@leverege/plugin';
import TimelineModel from "./TimelineModel.js";
import S from './TimelineModelEditor.css';
import UnitEditor from "./TickUnitEditor.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('rsrc.dataViewers.editors.TimelineModelEditor');
const ALLOWED_REGEX = /^[_a-zA-Z][/a-zA-Z0-9_-]*[^/]$/;
export default function TimelineModelEditor(props) {
  const {
    value
  } = props;
  const onChange = useValueChange(TimelineModel, props);
  const validator = useCallback(value => {
    const valid = value && ALLOWED_REGEX.test(value);
    return valid;
  }, []);
  const tickValue = TimelineModel.getTickWindowDuration(value);
  const onClearTickWindowDuration = useCallback(() => {
    onChange({
      data: 'setTickWindowDuration',
      value: null
    });
  }, [onChange]);
  return /*#__PURE__*/_jsxs(TabPane, {
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabId: "options",
      tabName: "Options",
      children: /*#__PURE__*/_jsxs(PropertyGrid, {
        className: S.editor,
        variant: "editor",
        children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('dateRange'),
          children: /*#__PURE__*/_jsx(DateTimeRangePicker, {
            value: TimelineModel.getRange(value),
            eventData: "setRange",
            onChange: onChange
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('pathPrefix'),
          children: /*#__PURE__*/_jsx(TextInput, {
            validator: validator,
            onChange: onChange,
            eventData: "setPathPrefix",
            value: TimelineModel.getPathPrefix(value)
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: "Tick Window Length",
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            children: [/*#__PURE__*/_jsx(UnitEditor, {
              onChange: onChange,
              eventData: "setTickWindowDuration",
              value: tickValue,
              valueType: "time",
              units: ['s', 'min', 'h', 'day'],
              hideDefault: true
            }), tickValue && /*#__PURE__*/_jsx(Button, {
              icon: "fa fa-fw fa-close",
              variant: "linkNoPad",
              onClick: onClearTickWindowDuration
            })]
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: "Tick Interval",
          children: /*#__PURE__*/_jsx(Flex, {
            variant: "rowM",
            children: /*#__PURE__*/_jsx(UnitEditor, {
              onChange: onChange,
              eventData: "setTickInterval",
              value: TimelineModel.getTickInterval(value),
              valueType: "time",
              units: ['s', 'ms'],
              hideDefault: true
            })
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: "Query Precision",
          children: /*#__PURE__*/_jsx(Flex, {
            variant: "rowM",
            children: /*#__PURE__*/_jsx(UnitEditor, {
              onChange: onChange,
              eventData: "setPrecision",
              value: TimelineModel.getPrecision(value),
              valueType: "time",
              units: ['s', 'min', 'h', 'day'],
              hideDefault: true
            })
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Header, {
          title: "View Options"
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          children: ModelTypeSelector.createSelectorAndEditor({
            values: Plugins.get('RsrcThumbnailRendererModel'),
            value: TimelineModel.getThumbnail(value),
            eventData: 'setThumbnail',
            onChange,
            allowNone: false,
            isPropertyGrid: true,
            showInline: false,
            label: 'Thumbnail View'
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          children: ModelTypeSelector.createSelectorAndEditor({
            values: Plugins.get('RsrcDetailRendererModel'),
            value: TimelineModel.getDetail(value),
            eventData: 'setDetail',
            onChange,
            allowNone: false,
            isPropertyGrid: true,
            showInline: false,
            label: 'Selected View'
          })
        })]
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabId: "details",
      tabName: "Details",
      children: /*#__PURE__*/_jsx(ItemEditor, {
        eventData: "setDetails",
        onChange: onChange,
        value: TimelineModel.getDetails(value)
      })
    })]
  });
}